<template>
  <div class="ac-card-content">
    <div class="ac-body-container">
      <div class="ac-header">
        Promo Wizard Help
      </div>
      <div class="ac-info-container">
        <div class="ac-info-header">
          Add Image
        </div>
        <div class="ac-info-body">
          <b>Upload an image to show on the member's in-app Rewards page.</b>
          This image will be also be used on the preview. Accepted formats: .jpeg and .png
        </div>
        <div class="ac-info-body">
          When creating a custom promo, both the preview and main images must be provided.
        </div>
        <div class="ac-info-body">
          <b>Preview Image:</b><br>
          Maximum size 280px by 80px
        </div>
        <div class="ac-info-body">
          <b>Main Image:</b><br>
          Maximum size 264px by 160px
        </div>
      </div>
      <div class="ac-button-container">
        <button
          type="button"
          class="ac-button"
          @click="close"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddImage',
  props: {
    close: Function,
  },
};
</script>
